export default __webpack_public_path__ + "static/media/head03_ko_pc.23d835fe.png";